var slider1 = new Swiper('.slider1', {
    loop: true,
    spaceBetween: 0,
    centeredSlides: false,
    speed: 1200,
    loopFillGroupWithBlank: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function(index, className) {
            return '<span class="' + className + '"></span>';
        },
    },
    autoplay: {
        delay: 5000,
    },
    slidesPerView: 1,
    slidesPerColumn: 1,
    initialSlide: 0,
    breakpoints: {
        1080: {
            slidesPerView: 'auto',
            centeredSlides: true,
        },
    },
on: {
      init: function(swiper) {
            // Check if Swiper is in desktop breakpoint
            if (window.innerWidth >= 1080) {
                swiper.slideNext(0); // Move to the next slide immediately after initializing
            }
        },
    },
});

/*  var slider2 = new Swiper('.slider2', {
    loop: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    centeredSlidesBounds: true,
    spaceBetween: 0,
    speed: 1200,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

}); 
 */

// Initialize Swiper
var slider2 = new Swiper('.slider2', {
  loop: true,
  slidesPerView: 'auto',
  centeredSlides: true,
  centeredSlidesBounds: true,
  spaceBetween: 0,
  speed: 1200,
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
  on: {
    init: function() {
        console.log('Swiper initialized');
        this.slideToLoop(0, 0);  // Jump to the first slide in the loop on init
        preloadNextSlides(this); // Preload slides on init
    },
      transitionStart: function() {
          console.log('Transition started at slide:', this.activeIndex);
          preloadBasedOnDirection(this); // Preload based on direction when the slider starts moving
      }
  }
});

// Function to determine direction and preload the appropriate slides
function preloadBasedOnDirection(swiperInstance) {
  const direction = swiperInstance.swipeDirection;
  console.log(`Swipe direction: ${direction}`);

  if (direction === 'next') {
      // Moving forward, preload next 10 slides
      preloadNextSlides(swiperInstance);
  } else if (direction === 'prev') {
      // Moving backward, preload previous 10 slides
      preloadPreviousSlides(swiperInstance);
  }
}

// Function to preload images for the next 10 slides
function preloadNextSlides(swiperInstance) {
  const totalSlides = swiperInstance.slides.length;
  const currentIndex = swiperInstance.activeIndex;

  console.log(`Preloading next 10 slides from active index: ${currentIndex}`);
  console.log(`Total slides: ${totalSlides}`);

  // Preload the next 10 slides
  for (let i = 1; i <= 10; i++) {
      let nextSlideIndex = (currentIndex + i) % totalSlides; // Handle looped slides forward

      // Preload the next slide
      preloadSlideImages(swiperInstance.slides[nextSlideIndex], nextSlideIndex);
  }
}

// Function to preload images for the previous 10 slides
function preloadPreviousSlides(swiperInstance) {
  const totalSlides = swiperInstance.slides.length;
  const currentIndex = swiperInstance.activeIndex;

  console.log(`Preloading previous 10 slides from active index: ${currentIndex}`);
  console.log(`Total slides: ${totalSlides}`);

  // Preload the previous 10 slides
  for (let i = 1; i <= 10; i++) {
      let previousSlideIndex = (currentIndex - i + totalSlides) % totalSlides; // Handle looped slides backward

      // Preload the previous slide
      preloadSlideImages(swiperInstance.slides[previousSlideIndex], previousSlideIndex);
  }
}

// Helper function to preload images in a slide
function preloadSlideImages(slide, slideIndex) {
  // Check if the slide exists
  if (slide) {
      console.log(`Preloading images for slide index: ${slideIndex}`);

      // Find all lazy-loaded images within this slide
      let lazyImages = slide.querySelectorAll('img.lazy-image');

      // Load each lazy image by setting src from data-src
      lazyImages.forEach((img) => {
          // Check if the image has already been loaded (using data-loaded attribute)
          if (!img.dataset.loaded) {
              // Set the real image URL to src and mark as loaded
              img.src = img.dataset.src;
              img.classList.remove('lazy-image');
              img.setAttribute('data-loaded', 'true'); // Mark the image as loaded
              console.log(`Preloaded image in slide: ${slideIndex}`, img.src); // Debug log with the image URL
          } else {
              console.log(`Image in slide ${slideIndex} already loaded`);
          }
      });
  } else {
      console.log(`Slide is undefined for index: ${slideIndex}`);
  }
}










var slider3 = new Swiper('.slider3', {
  loop: true,
  slidesPerView: 2,
  slidesPerGroup: 1,
  spaceBetween: 0,
  speed: 1200,
  centeredSlides: false,
  loopFillGroupWithBlank: true,
  //roundLengths: true,
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },

});

// product PCで左右ブロック分けた親divをスマホで消す
if (window.matchMedia( "(max-width: 749px)" ).matches) {
    $(function(){
     $(".p_item_img_wrap,.p_colum3").unwrap();
    })
}


// 増減ボタン
(function () {
  var _dispatchQuantityChangeEvent = function (el) {
    if (document.createEvent) {
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent("change", true, true);
      return el.dispatchEvent(evt);
    } else {
      return el.fireEvent("onchange", document.createEventObject());
    }
  };

  $.fn.activateSpinner = function (targetInputElem, spinSpeed, spinStartWait) {
    spinStartWait = spinStartWait || 600;
    spinSpeed = spinSpeed || 30;
    var min = Number(targetInputElem.getAttribute("min")) || 0;
    var max = Number(targetInputElem.getAttribute("max")) || 50;

    var $spinnerButtons = this;

    var updateDisableState = function () {
      var value = Number(targetInputElem.value);
      $spinnerButtons.each(function () {
/*         var calc = Number(this.getAttribute("data-cal"));
        this.disabled =
          (0 < calc && max <= value) || (calc < 0 && value <= min);

        this.style.opacity = this.disabled ? "0.3" : "1.0"; */
      });
    };
    updateDisableState();

    return $spinnerButtons.each(function () {
      var calc = Number(this.getAttribute("data-cal"));
      if (!calc) return;

      /**
       * 画面上の数量を変更する
       * @returns {number|false} 値が更新された場合にはその数量、更新しない場合はfalseを返す
       */
      var updateElemValue = function () {
        var currentValue = Number(targetInputElem.value);
        var value = Math.max(min, Math.min(max, currentValue + calc));

        if (currentValue !== targetInputElem.value) {
          targetInputElem.value = value;
          return value;
        } else {
          return false;
        }
      };

      var valueAtSpinStart;
      var nextSpinTimeout = false;

      var startSpinLock = null;
      var startSpin = function () {
        if (startSpinLock) return;
        startSpinLock = setTimeout(function () {
          startSpinLock = null;
        }, 110);
        valueAtSpinStart = Number(targetInputElem.value);
        if (false !== updateElemValue()) {
          reserveNextSpin(spinStartWait);
        }
      };
      var reserveNextSpin = function (wait) {
        nextSpinTimeout = setTimeout(function () {
          var value = updateElemValue();
          if (value !== false) {
            reserveNextSpin();
          } else {
            stopSpin();
          }
        }, wait || spinSpeed);
      };
      var stopSpin = function () {
        if (nextSpinTimeout) {
          clearTimeout(nextSpinTimeout);
          nextSpinTimeout = false;
          if (
            Number(targetInputElem.value) === 0 &&
            !window.confirm("カートから商品を削除します")
          ) {
            targetInputElem.value = 1;
          }
          if (valueAtSpinStart !== Number(targetInputElem.value)) {
            updateDisableState();
            _dispatchQuantityChangeEvent(targetInputElem);
          }
        }
      };

      $(this).on("touchstart mousedown", function () {
        startSpin();
      });
      $(document).on("touchend mouseup scroll", function () {
        stopSpin();
      });
    });
  };
})($);
$(function () {
  // Activate spininer
  var initialize = function () {
    [].forEach.call(
      document.querySelectorAll("[data-quantity-input]"),
      function (inputElem) {
        var activated = $(inputElem).data("spinner-activated");
        if (!activated) {
          $(inputElem).data("spinner-activated", "1");
          $(inputElem)
            .closest(".spinner_area")
            .find(".btnspinner")
            .activateSpinner(inputElem);
        }
      }
    );
  };

  initialize();

  // thema がカート更新時にイベントを発火しない? + カートのHTML全書換するので、
  // やむを得ずタイマによる監視 + 初期化を仕掛ける
  setInterval(initialize, 80);
});

// cart 画面向けの消費税額表示の維持
document.addEventListener('DOMContentLoaded', function() {
    if(typeof cartItemsInformation === 'undefined') return;

    var checkIfExtraRenderRequired = function () {
        var required = false;
        [].forEach.call(
          document.querySelectorAll("[data-cart-item-key]"),
          function (itemKeyElem) {
            var activated = $(itemKeyElem).data("extra-rendered");
            required |= !activated;
            $(itemKeyElem).data("extra-rendered", true);
          }
        );
        return required;
      };
    
    var extraRender = function() {
        $('[data-cart-line-items]').find('[data-cart-item-key]').each(function() {
            var itemKey = $(this).attr('data-cart-item-key');
            var itemData = itemKey in cartItemsInformation ? cartItemsInformation[itemKey] : null;
            if(!itemData) return;

            $(this).find('[data-cart-item-price-list]')
                .removeClass('cart_tax8 cart_tax10')
                .toggleClass('cart_tax'+itemData.tax_rate.toString(), !!itemData.tax_rate);
        })
    };

    extraRender();
    // thema がカート更新時にイベントを発火しない? + カートのHTML全書換するので、
    // やむを得ずタイマによる監視 + 初期化を仕掛ける
    setInterval(function(){
        checkIfExtraRenderRequired() && extraRender();
    }, 80);
});


// navigation
$(function () {
  $(".top_icolist_hide").hide();

  // (1)ヘッダーとナビゲーション状態の定義
  var naviState = {
    activeTopIco: undefined, // 'member'|'login'|'search'
    activePcNav: undefined, // 'category'|'origin'|'winery'|'variety'|'price'
    activeMobileNav: undefined, // 'global'|'m_category'|'m_origin'|'m_winery'|'m_varienty'|'m_price',
    timeoutCollection: []
  };

  // (2) bodyクリックで状態を初期化するための変数
  var updateCalled = false;

  // (3) 状態の変更に対する描画状態を変更する関数
  function updateStateFromTo(changes) {
    updateCalled = true;

    var newState = Object.assign({}, naviState, changes);
    var stateWillChange = Object.keys(newState).some(function (k) {
      return naviState[k] !== newState[k];
    });
    if (!stateWillChange) return;

    // 背景白
    $("body").toggleClass(
      "bg-white",
      !!(
        newState.activeTopIco ||
        newState.activePcNav ||
        newState.activeMobileNav
      )
    );

    // TOPアイコンに対応するサブメニュー
    var topIcoSelectors = {
      member: ".top_icolist_hide.top_icolist_in1",
      login: ".top_icolist_hide.top_icolist_in2",
      search: ".top_icolist_hide.top_icolist_in3",
    };
    if (naviState.activeTopIco !== newState.activeTopIco) {
      Object.keys(topIcoSelectors).forEach(function (ico) {
        var selector = topIcoSelectors[ico];
        if (newState.activeTopIco === ico) {
          $(selector).slideDown(320);
        } else if (naviState.activeTopIco === ico) {
          $(selector).slideUp(200);
        }
      });
    }

    // PC navi
    var pcNavSelectors = {
      category: "#pc_nav_link-category+.top_nav_second",
      origin: "#pc_nav_link-origin+.top_nav_second",
      winery: "#pc_nav_link-winery+.top_nav_second",
      variety: "#pc_nav_link-variety+.top_nav_second",
      price: "#pc_nav_link-price+.top_nav_second",
    };
    if (naviState.activePcNav !== newState.activePcNav) {
      naviState.timeoutCollection.forEach(function(t){
        clearTimeout(t);
      });
      Object.keys(pcNavSelectors).forEach(function (pcNav) {
        var selector = pcNavSelectors[pcNav];
        if (newState.activePcNav === pcNav) {
          $(selector).slideDown(320);
          $(selector).find('.top_nav_second_in li').each(function(i, liElem){
            var timeout = setTimeout(function() {
              $(liElem).addClass('top_nav_second_order_on');
            }, 1 * i + 0);
            newState.timeoutCollection.push(timeout);
          });
        } else if (naviState.activePcNav === pcNav) {
          $(selector).slideUp(200);
          $(selector).find('.top_nav_second_in li').each(function(i, liElem){
            $(liElem).removeClass('top_nav_second_order_on');
          });
        }
      });
    }

    // mobile navi
    var mnavActive = !!newState.activeMobileNav;
    var mnavIsParent = newState.activeMobileNav === "global";
    var mnavChild =
      mnavActive && !mnavIsParent ? newState.activeMobileNav : undefined;

    $(".toggle_btn").toggleClass("active", mnavActive);
    $(".mnav_wrap").toggleClass("mnav_open", mnavActive);
    $(".mnav_parent").toggleClass("mnav_close", mnavActive && !mnavIsParent);

    $(".m_category").toggleClass("mnav_open", mnavChild === "m_category");
    $(".m_origin").toggleClass("mnav_open", mnavChild === "m_origin");
    $(".m_winery").toggleClass("mnav_open", mnavChild === "m_winery");
    $(".m_varienty").toggleClass("mnav_open", mnavChild === "m_varienty");
    $(".m_price").toggleClass("mnav_open", mnavChild === "m_price");

    if(!naviState.activeMobileNav && !!newState.activeMobileNav) {
      $(".mnav_wrapall").slideDown(640);
    } else if(!!naviState.activeMobileNav && !newState.activeMobileNav) {
      $(".mnav_wrapall").slideUp(200);
    }

    naviState = newState;
  }

  // (4) 状態を変更させるための関数(状態の変更のみで描画については操作しない)
  function setMobileMenu(activeMobileNav) {
    updateStateFromTo({
      activeTopIco: undefined,
      activePcNav: undefined,
      activeMobileNav: activeMobileNav,
    });
  }
  function setActiveTopIco(topIco) {
    updateStateFromTo({
      activeTopIco: topIco,
      activePcNav: undefined,
      activeMobileNav: undefined,
    });
  }
  function setActiveMenuItem(pcNav) {
    updateStateFromTo({
      activeTopIco: undefined,
      activePcNav: pcNav,
      activeMobileNav: undefined,
    });
  }
  function resetState() {
    updateStateFromTo({
      activeTopIco: undefined,
      activePcNav: undefined,
      activeMobileNav: undefined,
    });
  }

  // (5) 画面上の部品から(4)を呼び出させるための設定

  // 上部>会員アイコン
  $("#top_icolist_in1").on("click", function (ev) {
    if (naviState.activeTopIco !== "member") {
      setActiveTopIco("member");
    } else {
      resetState();
    }
  });
  // 上部>ログインアイコン
  $("#top_icolist_in2").on("click", function (ev) {
    if (naviState.activeTopIco !== "login") {
      setActiveTopIco("login");
    } else {
      resetState();
    }
  });
  // 上部>検索アイコン(虫眼鏡)
  $("#top_icolist_in3").on("click", function (ev) {
    if (naviState.activeTopIco !== "search") {
      setActiveTopIco("search");
    } else {
      resetState();
    }
  });
  // 上部アイコンから出現したサブメニュー内の閉じるボタン
  $(".icon_close_btn").on("click", function (ev) {
    resetState();
  });

  // [モバイル向けメニュー] メニュー表示/閉じるボタン
  $(".toggle_btn").on("click", function (ev) {
    if (!!naviState.activeMobileNav) {
      resetState();
    } else {
      setMobileMenu("global");
    }
  });
  // [モバイル向けメニュー] メニューインデックス中のサブメニューを開くボタン
  $(".mnav_btn").click(function () {
    setMobileMenu($(this).attr("id"));
  });
  // [モバイル向けメニュー] サブメニューからインデックスへ戻るボタン
  $(".mnav_rtnbtn").click(function () {
    setMobileMenu("global");
  });

  // [PC向けメニュー] カテゴリ
  $(".pc_nav_link").on("click", function (ev) {

  });
  $("#pc_nav_link-category").on("click", function (ev) {
    if (naviState.activePcNav !== "category") {
      setActiveMenuItem("category");
    } else {
      resetState();
    }
  });
  // [PC向けメニュー] 産地
  $("#pc_nav_link-origin").on("click", function (ev) {
    if (naviState.activePcNav !== "origin") {
    setActiveMenuItem("origin");
    } else {
      resetState();
    }
  });
  // [PC向けメニュー] ワイナリー
  $("#pc_nav_link-winery").on("click", function (ev) {
    if (naviState.activePcNav !== "winery") {
    setActiveMenuItem("winery");
    } else {
      resetState();
    }
  });
  // [PC向けメニュー] 品種
  $("#pc_nav_link-variety").on("click", function (ev) {
    if (naviState.activePcNav !== "variety") {
    setActiveMenuItem("variety");
    } else {
      resetState();
    }
  });
  // [PC向けメニュー] 価格
  $("#pc_nav_link-price").on("click", function (ev) {
    if (naviState.activePcNav !== "price") {
    setActiveMenuItem("price");
    } else {
      resetState();
    }
  });
  // [PC向けメニュー] 各サブメニューボタンからサブメニューを閉じるボタン
//  $(".pc_close_btn").on("click", function (ev) {
//    resetState();
//  });

  // [共通] 特定の要素以外をクリックでメニューなどを閉じる
  $("body").on("click", function (ev) {
    var preventResetState =
      0 <
      $(ev.target).closest("nav, .top_icolist_hide, .toggle_btn, .mnav_wrapall")
        .length;
    if (preventResetState) return;

    if (!updateCalled) resetState();
    updateCalled = false;
  });
});


//winery-liet 絞り込み
$(function(){
  var $btn = $('.w_list_nav [data-filter]'),
  $list = $('.w_list_box_wrap [data-category]');
   
  $btn.on('click', function(e) {
    e.preventDefault();
     
    var $btnTxt = $(this).attr('data-filter');
     
    if ($btnTxt == 'all'){
      $list.fadeOut().promise().done(function() {
        $list.fadeIn();
      });
    } else {
      $list.fadeOut().promise().done(function() {
        $list.filter('[data-category = "' + $btnTxt + '"]').fadeIn();
      });
    }
  });
});

// about wasyu

$(function(){
　$(window).scroll(function (){
    $('.top_about_wasyu').each(function(){
        var elemPos = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scroll > elemPos - windowHeight + 300){
            $(this).addClass('top_about_wasyu_ani');
        }
    });
　});
});

// sp footer jun group
if (window.matchMedia( "(max-width: 768px)" ).matches) {
    $(function(){
        $('.footer_store_link_title').on('click',function(){
            $(this).next().slideToggle();
            $(this).toggleClass('footer_store_link_title_c');

        });
    })
}

//scroll top
  let $pagetop = $('.scrooltop');

  $(window).on( 'scroll', function () {
    if ( $(this).scrollTop() < 1000 ) {
      $pagetop.removeClass('isActive');
    } else {
      $pagetop.addClass('isActive');
    }
  });
 $('a[href^="#"]').on('click', function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop: position}, 550, "swing");
    return false;
  });

//label list
if($(".auto_height").length){
    $(function(){
        var liObj = '.auto_height li';
        var liL = $(liObj).length;
        var l = $(liObj).children().length / liL;
        var colNum = Math.floor($('.auto_height').width() / $(liObj).outerWidth());
        var rowNum = Math.ceil(liL / colNum);
        var cBase = f = 0;
        var maxHeight = new Array(l);

        var lastInnerWidth = window.innerWidth;

        var w=$(liObj).outerWidth();
        console.log(w);

    $(window).on('load',function(){
          for(r=0; r<rowNum; r++){
          for(i=0; i<l; i++) maxHeight[i] = 0;
          cBase = r * colNum;

          for(c=0; c<colNum; c++){
              for(i=0; i<l; i++){
                  if($(liObj).eq(cBase + c).children().eq(i).height() > maxHeight[i])　maxHeight[i] = $(liObj).eq(cBase + c).children().eq(i).height();
              } 
          }

          for(c=0; c<colNum; c++){
              for(i=0; i<l; i++){
                  $(liObj).eq(cBase + c).children().eq(i).height(maxHeight[i]);
              }
              if((cBase + c + 1) >= liL) {
                  f = 1;
                  break;
              }
          }
          if(f) break;
      }
    })

    $(window).on('resize', function() {
        if ( lastInnerWidth != window.innerWidth ) {
            lastInnerWidth = window.innerWidth ;
            setTimeout('location.reload();', 100);
        }
    });

    })

}

//faq
$("dl.faq dt").on("click", function () {
  $(this).next('dd').slideToggle(200);
  $(this).toggleClass('faq_active');
});

(function() {
  //該当フォーム
  var hadr = document.querySelector(".h-adr"), 
      cancelFlag = true;

  //イベントをキャンセルするリスナ
  var onKeyupCanceller = function(e) {
      if(cancelFlag){
          e.stopImmediatePropagation();
      }
      return false;
  };

  // 郵便番号の入力欄
  var postalcode = hadr.querySelectorAll(".p-postal-code"),
      postalField = postalcode[postalcode.length - 1];

  //通常の挙動をキャンセルできるようにイベントを追加
  postalField.addEventListener("keyup", onKeyupCanceller, false);

  //ボタンクリック時
  var btn = hadr.querySelector(".postal-search");
  btn.addEventListener("click", function(e) {
      //キャンセルを解除
      cancelFlag = false;

      //発火
      let event;
      if (typeof Event === "function") {
          event = new Event("keyup");
      } else {
          event = document.createEvent("Event");
          event.initEvent("keyup", true, true);
      }
      postalField.dispatchEvent(event);

      //キャンセルを戻す
      cancelFlag = true;
  });
})();

